import { setGlobalContext } from 'src/services/datadog';
import { setDatadogAction } from 'src/services/datadog';
import { v4 as uuidv4 } from 'uuid'

const getOrCreateBrowserKey = (() => {

    async function getOrCreateBrowserKey(keyToSet = null) {
        const storageKey = "browser";

        try {
            if (keyToSet && typeof keyToSet === 'string') {
                localStorage.setItem(storageKey, keyToSet);
                
                setGlobalContext({ device_key: keyToSet });
                return keyToSet;
            }
            
            const storedKey = localStorage.getItem(storageKey);

            if (storedKey) {
                setDatadogAction('device_key_retrieved', { storedKey });
                setGlobalContext({ device_key: storedKey });
                return storedKey;
            }

            const keyToSave = uuidv4();
            localStorage.setItem(storageKey, keyToSave);

            setDatadogAction('device_key_created', { keyToSave });
            setGlobalContext({ device_key: keyToSave });
            
            return keyToSave;

        } catch (error) {
            setDatadogAction('device_key_retrieval_failed', { error: error });
            console.error("Error handling localStorage:", error);
            return "Error handling localStorage";
        }
    }

    return getOrCreateBrowserKey;
})();

export { getOrCreateBrowserKey };